import React, { useMemo } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { SecurityDataEditorProps } from './SecurityDataEditor.props';
import { useCashFlowContext } from '../context/CashFlowContext';

const SecurityDataEditor = (props: SecurityDataEditorProps) => {
  const { cell } = props;
  const { allowedSecurityOptionsByEntity } = useCashFlowContext();

  // Find the entity cell in the same row
  const entityCell = useMemo(
    () =>
      Object.values(cell.sheet?.cells ?? {}).find(
        c => c.alias === 'entity' && c.rowNumber === cell.rowNumber
      ),
    [cell.sheet?.cells, cell.rowNumber]
  );

  // Get the entity value and extract the company ID from it
  const entityId = useMemo(() => {
    if (!entityCell?.value || typeof entityCell.value !== 'string') {
      return null;
    }
    if (entityCell.value.startsWith('company-')) {
      return parseInt(entityCell.value.replace('company-', ''), 10);
    }
    return null;
  }, [entityCell?.value]);

  // Offer only fund-ownership securities for the selected entity, or across
  // all entities if no entity is selected
  const securityOptions = useMemo(() => {
    if (entityId && allowedSecurityOptionsByEntity[entityId]) {
      return allowedSecurityOptionsByEntity[entityId];
    }
    return Object.values(allowedSecurityOptionsByEntity).flat();
  }, [entityId, allowedSecurityOptionsByEntity]);

  return <GridSelect menuPosition="fixed" usePortal options={securityOptions} {...props} />;
};

export default SecurityDataEditor;
